import { useQuery } from '@tanstack/react-query'

import { IGenericJob } from '@interfaces/task/generic/IGenericJob'
import { api } from '@services/apiClient'

import { useFindProfile } from './profile'

export function useFindJob(id: number) {
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  async function fetchJob() {
    const { data } = await api.get<IGenericJob>(`sites/${siteId}/jobs/${id}`)

    return data
  }

  return useQuery({ queryFn: fetchJob, queryKey: ['JOB', id] })
}
